import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {MvsCrudService} from '../../../../core/shared/service/crud/mvs-crud.service';
import {XxFormLogicScenarioDto} from '../../model/dto/api/xx-form-logic-scenario.dto';

/**
 * Client for the XX Form-Logic Playground runtime endpoints
 * ({@code /mvsa/xx/formLogicPlayground}).
 *
 * These are plain action endpoints, not entity CRUD — the seeded artefacts themselves
 * (`cc.FormLogic`, `lg.Logic`, `xx.XxGenericTestType`) are managed through their own
 * generic CRUD services afterwards.
 */
@Injectable({
    providedIn: 'root'
})
export class XxFormLogicPlaygroundService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/xx/formLogicPlayground');
    }

    /**
     * The scenario catalogue, including each scenario's `typeId` — the value the form's
     * type field is pre-set to, which is what selects the scenario at render time.
     */
    public scenarios(): Observable<XxFormLogicScenarioDto[]> {
        return this.getInternalEndpoint('/scenarios').pipe(
            map(result => result as unknown as XxFormLogicScenarioDto[])
        );
    }

    /** Whether the catalogue is installed on the current tenant. */
    public status(): Observable<{ seeded: boolean; scenarioCount: number }> {
        return this.getInternalEndpoint('/seed/status').pipe(
            map(result => result as unknown as { seeded: boolean; scenarioCount: number })
        );
    }

    /**
     * Runs the idempotent seed.
     *
     * @param force re-runs even when already seeded — also the way a changed script in
     *              `XxFormLogicSeedDefinition` reaches an already-seeded system.
     */
    public seed(force: boolean = false): Observable<any> {
        return this.postBasic<any>({}, '/seed?force=' + force);
    }
}
